import Chart from "react-apexcharts";
import { overallHeatMap } from "../../../services/api-services";
import { useEffect, useState } from "react";
import { toastEmitter } from "../../../utills/utilities";
import generateChartImage from "./generateChartImage";
import Remark from "./Remark";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const WeightedGapChart = ({ selectedCompanyId, graphName }) => {
  const [remark, setRemark] = useState(""); // For remark text
  const [remarkId, setRemarkId] = useState(null); // For remarkId
  const [isAttempt, setIsAttempt] = useState("")

  const options = {
    chart: {
      id: "gap_chart",
      type: "bar",
      height: 350,
      events: {
        mounted: () => {
          setTimeout(() => {
            generateChartImage("gap_chart", "gap_chart", remark); // Call the updated function here
          }, 100); // Delay in milliseconds (e.g., 100ms or adjust as necessary)
        },
      },
      stacked: false,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "45%",
        dataLabels: {
          enabled: false,
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (value) => `${value}%`,
      style: {
        fontSize: "10px",
        fontWeight: "bold",
      },
    },
    grid: {
      show: false,
    },
    stroke: {
      width: 3,
      // colors: ["#333"],
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val?.toFixed(2)}%`;
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      fontSize: "14px",
      labels: {
        colors: ["#000"],
      },
      markers: {
        width: 12,
        height: 12,
        radius: 5,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
  };

  const [responseBody, setResponseBody] = useState([]);

  const [loading, setLoading] = useState(false);
  const getOverAllHeatMapData = async () => {
    setLoading(true);
    try {
      const response = await overallHeatMap(selectedCompanyId, graphName);
      if (response?.data?.responseCode === 200) {
        const remark = response?.data?.remark || "";
        const remarkId = response?.data?.remarkId || null;
        const isAttempt = response?.data?.isAttempt ?? 0;

        // Set remark and remarkId to state
        setRemark(remark);
        setRemarkId(remarkId);
        setIsAttempt(isAttempt)
        setResponseBody(response?.data?.responseBody || []);
      } else if (response?.data?.responseCode === 404) {
        setResponseBody([]);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", "Service unavailable.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCompanyId) {
      getOverAllHeatMapData();
    }
  }, [selectedCompanyId]);

  const getChartData = () => {
    const subDimensions = [];
    const seriesData = [];

    let allSubDimensions = [];
    responseBody.forEach((dimension) => {
      dimension.subDimensionOverallHeatmapChartResponseList.forEach(
        (subDimension) => {
          allSubDimensions.push({
            name: subDimension.subDimensionName,
            percentage: subDimension.percentage,
          });
        }
      );
    });

    allSubDimensions = allSubDimensions.sort(
      (a, b) => b.percentage - a.percentage
    );

    allSubDimensions.forEach((subDimension) => {
      subDimensions.push(subDimension.name);
      seriesData.push(`${subDimension.percentage?.toFixed(2)}`);
    });

    options.xaxis.categories = subDimensions;

    return [
      {
        name: "Sub-Dimensions Percentages",
        data: seriesData,
      },
    ];
  };

  const series = getChartData();

  const exportSummaryToExcel = (data, fileName = "Dimension Participation Details") => {
    const title = [["Dimension Participation Details"]]; // Title
    const headers = ["Dimension/Subdimension Name", "Percentage"];

    const rows = [];

    data?.responseBody?.forEach(dimension => {
      // Add main dimension row
      rows.push([
        dimension?.dimensionName,
        dimension?.percentage?.toFixed(2)
      ]);

      // Add each subdimension row with indented name
      dimension?.subDimensionOverallHeatmapChartResponseList?.forEach(sub => {
        rows.push([
          `  - ${sub?.subDimensionName}`,
          sub?.percentage?.toFixed(2)
        ]);
      });
    });

    const sheetData = [...title, [], headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Merge title row across both columns
    worksheet["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: 1 }
      }
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, fileName);
  };


  return (
    <>
      <div className="text-end">
        <button className="px-3 py-2 text-white bg-primary rounded border-0" onClick={() => exportSummaryToExcel(responseBody)}>Download Excel</button>
      </div>
      <div className="weighted_gap_chart_content">
        {loading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : (
          <div className="chart6 " data-heading="Ordered Average Weighted Gap Chart" data-remark={remark}
          >
            <Chart options={options} series={series} type="bar" />
          </div>
        )}
        <Remark
          graphName="WeightedGapChart"
          selectedCompanyId={selectedCompanyId}
          initialRemark={remark}
          remarkId={remarkId}
          isAttempt={isAttempt}
          setRemarkprops={setRemark}
        />
      </div>
    </>

  );
};

export default WeightedGapChart;
